import React from "react"
import { FaYoutube } from "react-icons/fa"
import ExternalLink from "../ExternalLink"
//import * as styles from "./YoutubeLink.module.scss"

type YoutubeLinkProps = { account?: string | null; children?: React.ReactNode }

const YoutubeLink = ({ account, children }: YoutubeLinkProps) => {
  //console.log('Rendering YoutubeLink', props)
  if (!account) return null
  return (
    <ExternalLink href={`https://www.youtube.com/c/${account}`} title="Youtube">
      <FaYoutube />
      {children}
    </ExternalLink>
  )
}

export default YoutubeLink
